module.exports = __webpack_public_path__ + "static/media/rewards.a7b92a87.svg";